var _rect, _text, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg404Illustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 300,
    viewBox: "0 0 400 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 300,
    fill: "#f8f9fa"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 120,
    fontFamily: "Arial",
    fontWeight: "bold",
    fontSize: 80,
    fill: "#2e7d32"
  }, "404")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120 150 L280 150",
    stroke: "#e0e0e0",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M200 170 A50 50 0 0 0 200 270",
    stroke: "#2e7d32",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M170 220 L230 220",
    stroke: "#2e7d32",
    strokeWidth: 4,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404Illustration);
export default __webpack_public_path__ + "static/media/404-illustration.e20b2f7b4b396ce382e8372e0a36fe2e.svg";
export { ForwardRef as ReactComponent };